export const DLP_CHANNELS: string[] = [
    'online', 'facebook', 'twitter', 'instagram', 'youtube', 'tiktok',
    'weibo', 'xiaohongshu', 'douyin', 'bilibili', 'wechat_public'
];

export const DLP_GROUP_BY_OPTIONS: string[] = ['channel', 'label'];

export const DLP_RANKING_METRICS: string[] = ['miv'];
